import React, { useState } from 'react';
import axios from 'axios';
import { useHistory } from 'react-router-dom';
import { toast } from 'react-toastify';
import 'react-toastify/dist/ReactToastify.css';

toast.configure();

const AddSection = ({ id }) => {
  const [title, setTitle] = useState('');
  let history = useHistory();

  const handleSubmit = (e) => {
    e.preventDefault();
    var bodyFormData = new FormData();
    const URL = 'https://stucharge.bakersbrisk.com/api/sectionapi';
    const AuthStr = process.env.REACT_APP_AUTH_STR;
    bodyFormData.append('title', title);
    bodyFormData.append('course_id', id);
    // send section data to server
    axios
      .post(URL, bodyFormData, {
        headers: { Authorization: AuthStr },
      })
      .then(function (response) {
        if (response.status === 201)
          toast.success('Section added successfully!');
        history.push('/home');
        history.push(`/courses/${id}`);
      })
      .catch((error) => {
        toast.error('Something went wrong, please try again');
      });
  };

  return (
    <form
      className='class-form'
      style={{ width: '60%' }}
      onSubmit={(e) => handleSubmit(e)}
    >
      <div className='form-control'>
        <label htmlFor='Title'>Title</label>
        <input
          type='text'
          value={title}
          onChange={(e) => setTitle(e.target.value)}
        />
      </div>
      <button type='submit' className='btn'>
        Add Section
      </button>
    </form>
  );
};

export default AddSection;
